import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Sidebar from "../../../components/Sidebar";
import SizeList from "./SizeList";
import * as XLSX from "xlsx";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Preview from "./Preview";
import Header from "./Header";
import addImg from "./img/add-icn.svg";
import addAllSizesImg from "./img/add_all_sizes.svg";
import generateImg from "./img/generate-icn.svg";

import {
    changeDocumentTitle,
    sizeExcel,
    teeShirt_size,
    teeShirt_size_obj,
} from "../../../utils/helper";
import VariationCountLabel from "../../../components/VariationCountLabel";
import { useSelector, useDispatch } from "react-redux";
import {
    setTshirtDetails,
    addTshirtRow,
    removeTshirtRow,
    setExcelInfo,
} from "../../../redux/slices/variationSlice";
import { config } from "../../../utils/config";
import { clearThumb } from "../../../redux/slices/ThumbnailSlice";
import { updateDesign } from "../../../redux/slices/DesignSlice";
import { observer } from "mobx-react-lite";
import useDesignData from "../../../hook/useDesignData";
import { showToast } from "../../../redux/slices/ToastSlice";
import { designTypesEnum } from "../../../enums";
import KEYS from "../../../env/env";
import debounce from "lodash.debounce";
import InternetSpeedIndicator from "../../../components/InternetSpeedIndicator";
import { trackAnalyticsEvent } from "../../../utils/analytics";

const Variation = observer(({ store }) => {
    const userPlanDetails = useSelector((state) => state.userPlan);
    const selectedType = useSelector(
        (state) => state.sizeDimension.selectedType
    );
    const sizeDimensions = useSelector(
        (state) => state.sizeDimension.dimensions
    );

    const userLoginDetails = localStorage.getItem(config.USER_LOGIN_DETAILS);
    if (!userLoginDetails) {
        alert("please login first");
        navigate("/Login");
    }
    const [listIsChanged, setListIsChanged] = useState(false);
    const [filedata, setFileData] = useState(null);
    const [excelHead, setExcelHead] = useState([]);
    const [count, setCount] = useState(1);
    const [variationcount, setVariationCount] = useState(0);
    const [appendingRow, setAppendingRow] = useState([]);
    const [excelData, setExcelData] = useState(null);
    const [RemovedRow, setremovedRow] = useState([]);
    const [renderingTime, setRenderingTime] = useState(0.0);
    const [generateDisable, setGenerateDisable] = useState(true);
    const [isSaveDisabled, setSaveDisabled] = useState(true);
    const [nameValues, setNameValues] = useState(Array(10).fill(""));
    const [numberValues, setNumberValues] = useState(Array(3).fill(""));
    const [sizeValues, setSizeValues] = useState([]);
    const [designName, setDesignName] = useState("");

    const dispatch = useDispatch();
    const tshirtDetails = useSelector((state) => state.variation.tshirtDetails);
    const excelInfo = useSelector((state) => state.variation.excelInfo);
    // const { textFieldsNum, textFieldsName } = useSelector(
    //   (state) => state?.userPlan
    // );

    const message = useRef();
    const fieldShow = localStorage.getItem("fieldStatus");
    const fieldStatus = JSON.parse(fieldShow);
    const navigate = useNavigate();
    var CharCount = {};
    const fileInputField = useRef();
    var fileRecord = null;
    const [uploadExcelData, setUploadExcelData] = useState(null);
    const { id } = useParams();

    const setStoreData = async (data) => {
        console.log("setting store data", data);
        store.loadJSON(data);
        await store.waitLoading();
    };

    // Use the custom hook
    const {
        designInfo,
        isDesignLoading,
        hasDesignData,
        loadDesignDetail,
        setDesignDataToStore,
        resetDesignData,
        textFieldsName,
        textFieldsNum,
    } = useDesignData(store, setStoreData);


    const showName = designInfo?.store_data?.is_player_name_checked === true;
    const showNumber = designInfo?.store_data?.is_player_number_checked === true;

    useEffect(() => {
        if (designInfo?.size_data?.sizes) {
            let arr = [...designInfo?.size_data?.sizes];
    
            if (!arr[0]?.indexSr) {
                arr = arr.map((item, index) => ({
                    ...item,
                    indexSr: index + 1,
                }));
            }
    
            dispatch(setTshirtDetails(arr));
            setExcelData(arr);
    
            const hasName = arr.some(row => row.name && row.name.trim() !== "");
            const hasNumber = arr.some(row => {
                const num = row.number;
                return num != null && String(num).trim() !== '';
              });
              
            // console.log(hasName, hasNumber, 1111)
            const fromDesign = {
                name: !!designInfo?.store_data?.is_player_name_checked,
                number: !!designInfo?.store_data?.is_player_number_checked,
            };
    
            const finalFieldStatus = {
                name: fromDesign.name || hasName,
                number: fromDesign.number || hasNumber,
            };
    
            localStorage.setItem("fieldStatus", JSON.stringify(finalFieldStatus));
        }
    
        if (designInfo?.store_data?.excel_data) {
            dispatch(setExcelInfo(designInfo?.store_data?.excel_data));
            setUploadExcelData(designInfo?.store_data?.excel_data);
        }
    }, [designInfo]);


    useEffect(() => {
        // console.log("deepakvashisthdata designname is ",designInfo)
        if (designInfo?.design_name) {
            setDesignName(designInfo?.design_name);
            document.title = `${designInfo?.design_name} - Teedex`;
        }
    }, [designInfo]);

    // useEffect(() => {
    //   if (localStorage.getItem("excelInfo")) {
    //     const data = JSON.parse(localStorage.getItem("excelInfo"));
    //     setUploadExcelData({ ...data });
    //   }
    //   const storedDetails = JSON.parse(localStorage.getItem("tshirtDetails"));
    //   if (storedDetails) {
    //     let arr = [...storedDetails];

    //     if (!arr[0]?.indexSr) {
    //       arr = arr.map((item, index) => ({ ...item, indexSr: index + 1 }));
    //     }

    //     dispatch(setTshirtDetails(arr));
    //     setExcelData(arr);
    //   }

    //   const storedExcelInfo = JSON.parse(localStorage.getItem("excelInfo"));
    //   if (storedExcelInfo) {
    //     dispatch(setExcelInfo(storedExcelInfo));
    //   }
    // }, []);

    useEffect(() => {
        if (tshirtDetails.length > 0) {
            setGenerateDisable(false);
        } else {
            setGenerateDisable(true);
        }
    }, [tshirtDetails]);

    const normalizeSizeName = (size) => {
        // Convert to string and trim
        let normalizedSize = String(size).trim();

        // Replace "AGE" or "Age" with "Yr"
        normalizedSize = normalizedSize.replace(/AGE|Age/g, "Yr");

        // Replace spaces with underscores
        normalizedSize = normalizedSize.replace(/ /g, "_");

        // Replace "TO" with "-"
        normalizedSize = normalizedSize.replace(/_TO_/g, "-");

        return normalizedSize;
    };

    const processExcelData = (val) => {
        const size = val["size"] || "";
        const normalizedSize = normalizeSizeName(size);

        // Get dimensions from reducer
        const dimensions = sizeDimensions[normalizedSize];

        return {
            ...val,
            extraData: dimensions || null, // Add dimensions to extraData key
        };
    };

    const selectFile = (ev) => {
        const file = ev.target.files[0];
        if (!file) return;

        trackAnalyticsEvent("variation_import_sheet_select", {
            file_name: file.name,
            file_size_mb: Number((file.size / 1048576).toFixed(2)),
        });
    
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = (ev) => {
            const workbook = XLSX.read(ev.target.result, { type: "buffer" });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const headers = XLSX.utils.sheet_to_json(worksheet, {
                header: 1,
            })[0];
            const data = XLSX.utils.sheet_to_json(worksheet);
    
            const fieldStatus = JSON.parse(localStorage.getItem("fieldStatus"));

            // Decide once: should we read name/number from this Excel?
            const shouldReadName = showName || headers.some(h => /name/i.test(h));
            const shouldReadNumber = showNumber || headers.some(h => /number|no/i.test(h));

            const formattedData = data.map((val, index) => {
                let rowData = { indexSr: index + 1 };

                if (shouldReadName) {
                    rowData.name = val["name"] || val["Name"] || "";
                }
                if (shouldReadNumber) {
                    rowData.number = val["number"] || val["Number"] || val["No"] || "";
                }
                // size handling stays the same
                if (shouldShowSizeField) {
                    rowData.size = sizeExcel[val["size"]?.trim()]?.trim() || val["size"]?.trim() || "";
                }

                return processExcelData(rowData);
            });
            const processedData = formattedData;
            dispatch(setTshirtDetails(processedData)); // Update Redux state
            setExcelData(processedData);
            dispatch(setExcelInfo({ name: file.name, size: file.size }));

            dispatch(clearThumb());

            // localStorage.setItem("tshirtDetails", JSON.stringify(processedData));
            // localStorage.setItem(
            //   "excelInfo",
            //   JSON.stringify({ name: file.name, size: file.size })
            // );

            setUploadExcelData({ name: file.name, size: file.size });
            trackAnalyticsEvent("variation_import_sheet_success", {
                file_name: file.name,
                row_count: processedData.length,
            });

            setListIsChanged(true);

            setGenerateDisable(false);
        };
    };

    const handleInputChange = (index, field, value) => {
        let updatedData = tshirtDetails.map((item, i) =>
            i === index ? { ...item, [field]: value } : item
        );

        if (!updatedData[0]?.indexSr) {
            updatedData = updatedData.map((item, index) => ({
                ...item,
                indexSr: index + 1,
            }));
        }
        if (field === "size") {
            updatedData[index] = processExcelData(updatedData[index]);
          }

        dispatch(setTshirtDetails(updatedData));
        dispatch(clearThumb());
        setListIsChanged(true);
        // when there is something change then clear thumbs calls and new images should be generated
    };

    // const handleInputChange = (index, field, value) => {
    //     let updatedData = tshirtDetails.map((item, i) =>
    //       i === index ? { ...item, [field]: value } : item
    //     );
      
    //     // If size changed → regenerate extraData
    //     if (field === "size") {
    //       updatedData[index] = processExcelData(updatedData[index]);
    //     }
      
    //     dispatch(setTshirtDetails(updatedData));
    //     dispatch(clearThumb());
    //     setListIsChanged(true);
    //   };
      
    const upload_data = (e) => {
        e?.preventDefault();
        var fieldStatus = JSON.parse(localStorage.getItem("fieldStatus"));

        // localStorage.removeItem("tshirtDetails");

        var dataToPost = [];
        for (let i = 0; i < nameValues.length; i++) {
            if (
                nameValues[i] !== "" ||
                numberValues[i] !== "" ||
                sizeValues[i] !== ""
            ) {
                let dataToStore = { indexSr: i };
                if (fieldStatus.name) {
                    dataToStore["name"] = nameValues[i];
                }
                if (fieldStatus.number) {
                    dataToStore["number"] = numberValues[i];
                }
                dataToStore["size"] = sizeValues[i];

                // Process the size and get dimensions
                const processedData = processExcelData(dataToStore);
                dataToStore = {
                    ...dataToStore,
                    ...processedData,
                };

                dataToPost.push(dataToStore);
            }
        }

        // localStorage.setItem("tshirtDetails", JSON.stringify(dataToPost));
        dispatch(setTshirtDetails(dataToPost));
    };

    const addRow = (source = "add_button") => {
        const newRow = {
            indexSr: tshirtDetails.length + 1 || 1,
            name: "",
            number: "",
            size: "",
        };
        const updatedData = [...tshirtDetails, newRow];
        dispatch(addTshirtRow(newRow)); // Dispatch Redux action
        trackAnalyticsEvent("variation_add_row_click", {
            source,
            total_rows_after: updatedData.length,
        });
        // localStorage.setItem("tshirtDetails", JSON.stringify(updatedData));
    };

    const deleteRow = (index) => {
        const updatedData = tshirtDetails.filter((_, i) => i !== index);
        dispatch(removeTshirtRow(index)); // Dispatch Redux action
        // localStorage.setItem("tshirtDetails", JSON.stringify(updatedData));
    };

    const onSizeChange = (event) => {
        event.target.classList.remove("invalid");
        setSaveDisabled(false);
        upload_data(event);
        // setGenerateDisable(true);
    };

    const handleExportPage = () => {
        if (tshirtDetails.length === 0) {
            alert("No data available for export!");
            return;
        }


        if (selectedType !== "a1" && selectedType !== "a2" && selectedType !== "a3" && selectedType !== "a4" && selectedType !== "custom") {

            const found = tshirtDetails?.some(item => item.size === '')
            if (found) {
                dispatch(
                    showToast({
                        message: "One of data doen't have size selected, Please select size for all players",
                        type: "",
                    })
                );
                return;
            }

        }


        // return;
        let arr = [...tshirtDetails];

        // dispatch(setTshirtDetails(arr));

        let payload = {
            size_data: {
                sizes: tshirtDetails,
            },
            redirect_to: "export_page",
            store_data: {
                ...designInfo.store_data,
                excel_data: uploadExcelData,
            },
        };

        console.log("payload", payload);
        // return;
        dispatch(
            updateDesign({
                id,
                designData: payload,
            })
        );

        // localStorage.setItem("tshirtDetails", JSON.stringify(tshirtDetails));
        // navigate(`/export/${id}`, {
        //   state: {
        //     listIsChanged: listIsChanged,
        //     from: "variation",
        //     tshirtDetails: tshirtDetails,
        //   },
        // });
    };
    const handleDesignPage = () => {
        let payload = {
            size_data: {
                sizes: tshirtDetails,
            },
            redirect_to: "design_page",
            store_data: {
                ...designInfo.store_data,
                excel_data: uploadExcelData,
            },
        };

        console.log("payload", payload);

        dispatch(
            updateDesign({
                id,
                designData: payload,
            })
        );

        // localStorage.setItem("tshirtDetails", JSON.stringify(tshirtDetails));
        // navigate(`/export/${id}`, {
        //   state: {
        //     listIsChanged: listIsChanged,
        //     from: "variation",
        //     tshirtDetails: tshirtDetails,
        //   },
        // });
    };

    const divRef = useRef(null);

    const scrollToBottom = () => {
        divRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    const addAllSizes = () => {
        // Get all available sizes
        const allSizes = teeShirt_size.map((size) => size.value);

        // Get currently used sizes to avoid duplicates
        const usedSizes = tshirtDetails
            .map((row) => row.size)
            .filter((size) => size !== "");

        // Filter out sizes that are already added
        const availableSizes = allSizes.filter(
            (size) => !usedSizes.includes(size)
        );

        // Create new rows for each available size
        const newRows = availableSizes.map((size, index) => {
            const baseRow = {
            indexSr: tshirtDetails.length + index + 1,
            name: "",
            number: "",
            size: size,
            };
    
            return processExcelData(baseRow);
        });

        // Add all new rows
        newRows.forEach((row) => {
            dispatch(addTshirtRow(row));
        });

        trackAnalyticsEvent("variation_add_all_sizes_click", {
            added_count: newRows.length,
            total_rows_after: tshirtDetails.length + newRows.length,
        });
    };

    // Check if all sizes are already added
    const shouldShowAddAllSizesButton = () => {
        if (
            selectedType === designTypesEnum.CUSTOM ||
            selectedType === designTypesEnum.A4 ||
            selectedType === designTypesEnum.A3 ||
            selectedType === designTypesEnum.A2 ||
            selectedType === designTypesEnum.A1
        ) {
            return false;
        }
        // console.log(
        //   "deepakvashisth inside shouldShowAddAllSizesButton  uploadExcelData is ",
        //   uploadExcelData,
        //   " teeShirt_size is ",
        //   teeShirt_size,
        //   " tshirtDetails  is ",
        //   tshirtDetails
        // );
        // Only show the button if there are no imported Excel rows
        // This prevents interference with import functionality
        if (uploadExcelData) {
            return false;
        }

        const allSizes = teeShirt_size.map((size) => size.value);

        const usedSizes = tshirtDetails
            .map((row) => row.size)
            .filter((size) => size !== "");
        // console.log(
        //   "deepakvashisth inside shouldShowAddAllSizesButton ",
        //   "allSizes.every(size => usedSizes.includes(size))",
        //   allSizes.every((size) => usedSizes.includes(size))
        // );
        return !allSizes.every((size) => usedSizes.includes(size));
    };

    const token = localStorage.getItem("Login");
    const handleDesignRename = async (value) => {            
        const response = await fetch(
            KEYS.apiPath + "design/update/" + designInfo?.id,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    design_name: value,
                }),
            }
        );
        const data = await response.json();
        if (+data.resultFlag === 1) {
            changeDocumentTitle(value);
            dispatch(
                showToast({
                    message: "Name Updated successfully",
                })
            );
        }
    };

    const debouncedRename = useCallback(
        debounce(handleDesignRename, 800),
        [designInfo]
      );


    const handleSaveVariations = async () => {
        const sizes = tshirtDetails;
    
        if (!sizes || sizes.length === 0) {
            return dispatch(showToast({ message: "No data available to save!" }));
        }
    
        const payload = {
            size_data: { sizes },
            store_data: {
                ...designInfo.store_data,
                excel_data: uploadExcelData,
            },
        };
    
        try {
            await dispatch(
                updateDesign({
                    id,
                    designData: payload,
                })
            ).unwrap();
    

            changeDocumentTitle(designName);
    
            dispatch(showToast({ message: "Variations saved successfully" }));
        } catch (err) {
            console.error(err);
        }
    };
    
    const handleRenameAndSave = async (value) => {
        await handleDesignRename(value);
        await handleSaveVariations();
    };
    
    
    const designType = designInfo?.store_data?.selected_type?.toLowerCase();

    const shouldShowSizeField = designType 
        ? !["a1", "a2", "a3", "a4", "custom"].includes(designType)
        : false;

        // console.log(shouldShowSizeField, 5555)

    return (
        <>
            <div class="left-main-menu">
                <Sidebar />
            </div>
            <div class="artboard">
                {/* <Preview /> */}

                <div class="artboard--main variation-main">
                    <div class="artboard--main__header">
                        <div className="export--main__header--left--back">
                            <img
                                src="/assets/images/go-back-icn.svg"
                                alt=""
                                style={{
                                    marginRight: ".99vw",
                                    cursor: "pointer",
                                }}
                                onClick={() => navigate("/Design")}
                            />
                            {/* <a href="#"><img src="/assets/images/go-back-icn.svg" /></a> */}
                            <VariationCountLabel
                                userPlanDetails={userPlanDetails}
                            />
                            <InternetSpeedIndicator />
                        </div>

                            <div className="artboard--main__header--right variation-button">
                            <input
                                type="text"
                                placeholder="Enter design name"
                                value={designName}
                                name="designFileName"
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setDesignName(value);
                                    debouncedRename(value);  
                                    handleRenameAndSave(value);
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        handleRenameAndSave(designName);
                                    }
                                }}
                            />
                                        <button className="primary-button save-design-btn"
                                            onClick={() => {
                                                trackAnalyticsEvent("variation_save_click", {
                                                    row_count: tshirtDetails.length,
                                                });
                                                handleRenameAndSave(designName);
                                            }}
                                        >
                                        <img
                                            src={"/assets/images/save_icon.svg"}
                                            alt="Variation Icon"
                                        />
                                        Save
                                    </button>
                                </div>
                        <Header
                            generateImg={generateImg}
                            handleExportPage={handleExportPage}
                            generateDisable={generateDisable}
                            handleDesignPage={handleDesignPage}
                        />
                    </div>

                    <div class="artboard--main__text--content">
                        <div class="artboard--main__text--content--container">
                            <h2>
                                Easily Add or Upload Player Name, Number, and
                                Size
                            </h2>
                            <p>
                                Download the sample Excel template and fill it
                                with player names, numbers, and sizes. Upload
                                the completed Excel sheet to Teedex. (Note:
                                Teedex only supports <a href="#">THIS</a>{" "}
                                format.)
                            </p>
                            {/* <VariationCountLabel /> */}
                            <div class="artboard--main__text--content--buttons">
                                <button
                                    onClick={() => {
                                        addRow("add_manually");
                                        setTimeout(() => {
                                            scrollToBottom(); // Scroll after row is added
                                        }, 100);
                                    }}
                                    class="button-common button--light"
                                >
                                    Add manually
                                </button>
                                <p>Or</p>
                                {/* <input
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  type="file"
                  id="uploadbtn"
                  // className="upload_excel_input"
                  onChange={selectFile}
                /> */}

                                <div className="upload_excel_div">
                                    <input
                                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                        type="file"
                                        id="uploadbtn"
                                        // className="upload_excel_input"
                                        ref={fileInputField}
                                        onChange={(ev) => {
                                            selectFile(ev);
                                        }}
                                        onClick={() => {
                                            if (fileInputField.current) {
                                                fileInputField.current.value =
                                                    null;
                                            }
                                        }}
                                    />
                                    <h6>
                                        <img
                                            src="/assets/images/upload-file.svg"
                                            alt=""
                                        />
                                        Import Sheet
                                    </h6>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="artboard--main__variations">
                        <SizeList />

                        <div class="artboard--main__variations--inputs">
                            <div class="artboard--main__variations--inputs--heads">
                                <div class="artboard--main__variations--inputs--item">

                                    <div class="artboard--main__variations--inputs--name">
                                        Sr No.
                                    </div>

                                    {showName && (
                                        <div class="artboard--main__variations--inputs--name">
                                            Name
                                        </div>
                                    )}
                                    {showNumber && (
                                        <div class="artboard--main__variations--inputs--number">
                                            Number
                                        </div>
                                    )}
                                    {shouldShowSizeField && (
                                            <div class="artboard--main__variations--inputs--size">
                                                Size
                                            </div>
                                        )}
                                    {tshirtDetails?.length > 0 && (
                                        <button
                                            className="button-common button--light"
                                            onClick={() => {
                                                trackAnalyticsEvent("variation_clear_all_click", {
                                                    total_rows_before: tshirtDetails.length,
                                                });
                                                dispatch(setTshirtDetails([])); // Clear Redux state
                                                dispatch(setExcelInfo(null)); // Clear file info
                                                setExcelData([]); // Reset local state
                                                setAppendingRow([]); // Reset rows
                                                setUploadExcelData(null);
                                                localStorage.removeItem(
                                                    "tshirtDetails"
                                                );
                                                localStorage.removeItem(
                                                    "excelInfo"
                                                );
                                            }}
                                        >
                                            Clear All
                                        </button>
                                    )}
                                </div>
                            </div>
                            <div
                                ref={divRef}
                                className="artboard--main__variations--inputs--list"
                                id="variations--inputs--list"
                            >
                                {tshirtDetails?.map((value, index) => (
                                    <div>
                                        <div
                                            key={index}
                                            className="artboard--main__variations--inputs--item"
                                            id="variations--inputs--list"
                                        >
                                            <div className="artboard--main__variations--inputs--number">
                                                {index + 1}
                                            </div>

                                            {/* Name Input (conditionally rendered based on fieldStatus.name) */}
                                            {textFieldsName  && showName && (
                                                <div className="artboard--main__variations--inputs--name">
                                                    <input
                                                        type="text"
                                                        className="form-control tshirt-variant-data"
                                                        placeholder="-"
                                                        name="name[]"
                                                        value={value.name}
                                                        onChange={(e) =>
                                                            handleInputChange(
                                                                index,
                                                                "name",
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </div>
                                            )}

                                            {/* Number Input (conditionally rendered based on fieldStatus.number) */}
                                            {textFieldsNum  && showNumber && (
                                                <div className="artboard--main__variations--inputs--number">
                                                    <input
                                                        type="number"
                                                        className="form-control tshirt-variant-data"
                                                        placeholder="-"
                                                        name="number[]"
                                                        value={
                                                            value.number || ""
                                                        }
                                                        onChange={(e) =>
                                                            handleInputChange(
                                                                index,
                                                                "number",
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </div>
                                            )}
                                            {shouldShowSizeField && (
                                                    <div className="artboard--main__variations--inputs--size">
                                                        <select
                                                            className="form-control tshirt-variant-data"
                                                            name="size[]"
                                                            value={
                                                                value.size || ""
                                                            }
                                                            onChange={(e) =>
                                                                handleInputChange(
                                                                    index,
                                                                    "size",
                                                                    e.target
                                                                        .value
                                                                )
                                                            }
                                                        >
                                                            <option value="">
                                                                Select Size
                                                            </option>
                                                            {teeShirt_size.map(
                                                                (size) => (
                                                                    <option
                                                                        key={
                                                                            size.value
                                                                        }
                                                                        value={
                                                                            size.value
                                                                        }
                                                                    >
                                                                        {
                                                                            size.lable
                                                                        }
                                                                    </option>
                                                                )
                                                            )}
                                                        </select>
                                                    </div>
                                                )}
                                            <div>
                                                <button
                                                    className="button-common button--light"
                                                    onClick={() =>
                                                        deleteRow(
                                                            index,
                                                            "excel"
                                                        )
                                                    }
                                                >
                                                    Delete
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div
                                class="artboard--main__variations--inputs--add"
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                <button
                                    onClick={() => addRow("add_button")}
                                    class="button-common button--light"
                                    id="variations--inputs--add"
                                >
                                    <img src={addImg} alt="" /> Add
                                </button>{" "}
                                &nbsp;
                                {shouldShowAddAllSizesButton() && (
                                    <button
                                        onClick={addAllSizes}
                                        class="button-common button--light"
                                        id="variations--inputs--add"
                                    >
                                        <img src={addAllSizesImg} alt="" /> Add
                                        all Sizes
                                    </button>
                                )}
                                {/* <button
                  class="button-common button--light"
                  id="variations--inputs--add"
                  onClick={(e) => upload_data(e)}
                  disabled={isSaveDisabled}
                >
                  <img src={addImg} /> Save
                </button> */}
                            </div>
                        </div>
                        <div class="artboard--main__variations--actions">
                            <div class="artboard--main__variations--actions__block block-center">
                                <h4>Download Sample Sheet</h4>
                                <p>
                                    Perfect Your Results with This Excel
                                    Structure Download
                                </p>
                                <button
                                    class="button-common button--light download-doc"
                                    onClick={() => {
                                        trackAnalyticsEvent("variation_download_sample_click", {
                                            source: "variation_page",
                                        });
                                        const sampleFileUrl =
                                            // "https://variantwebmedia.s3.ap-south-1.amazonaws.com/excel%20/Sample%20Sheet%20Teedex.xlsx";
                                            "https://teedex.s3.ap-south-1.amazonaws.com/templates/NEW+SAMPLE+TEEDEX+(1).xlsx"; // latest excel sheet url
                                        const link =
                                            document.createElement("a");
                                        link.href = sampleFileUrl;
                                        link.setAttribute(
                                            "download",
                                            "Sample_Sheet_Teedex.xlsx"
                                        );
                                        document.body.appendChild(link);
                                        link.click();
                                        document.body.removeChild(link);
                                    }}
                                >
                                    <img
                                        src="/assets/images/download-doc.svg"
                                        alt=""
                                    />
                                    Download Sample
                                </button>
                            </div>
                            {tshirtDetails.length > 0 ? (
                                <div class="artboard--main__variations--actions__block">
                                    <h6>Total</h6>
                                    <h3>{tshirtDetails?.length} Variantions</h3>
                                </div>
                            ) : null}
                            {uploadExcelData && (
                                <>
                                    <div class="artboard--main__variations--actions__block">
                                        <h4>Uploaded File</h4>
                                        <h6>File Name</h6>
                                        <h3>
                                            {uploadExcelData?.name
                                                ? uploadExcelData.name
                                                : ""}
                                        </h3>
                                        <h6>File Size</h6>
                                        <h3>
                                            {uploadExcelData?.size
                                                ? (
                                                    uploadExcelData.size /
                                                    1048576
                                                ).toFixed(2)
                                                : "0.00"}{" "}
                                            mb
                                        </h3>
                                        {/* <div class="block-center">
                  <button
                    class="button-common button--dark button--black"
                    onClick={() => {
                      setFileData(null);
                      setExcelData([]);
                      setVariationCount(0);
                      setRenderingTime(0.0);
                      localStorage.removeItem("tshirtDetails");
                    }}
                  >
                    <img src={removeImg} /> 
                    Remove file
                  </button>
                </div> */}
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
});

export default Variation;
